// Slash-command registry for the chat composer. Mirrors the mobile app:
// reasoning commands are subscriber-only; pickers are available to everyone.
import { REASONING_OPTIONS } from "./reasoningModes";

export const buildSlashCommands = ({
  hasActiveSubscription,
  onReasoningMode,
  onPickPhotos,
  onPickFiles,
}) => [
  ...(hasActiveSubscription
    ? REASONING_OPTIONS.map((option) => ({
        key: `reasoning-${option.value}`,
        command: option.command,
        description: option.description,
        isMax: option.value === "max",
        run: () => onReasoningMode(option.value),
      }))
    : []),
  {
    key: "photo",
    command: "photo",
    description: "Choose from your library",
    run: onPickPhotos,
  },
  {
    key: "document",
    command: "document",
    description: "Browse files",
    run: onPickFiles,
  },
];

// "deep th" matches "deep-thinking": both sides are compared with
// hyphens/spaces stripped.
export const filterSlashCommands = (commands, query) => {
  const normalized = query.toLowerCase().replace(/[\s-]+/g, "");
  return commands.filter((item) =>
    item.command.replace(/-/g, "").startsWith(normalized),
  );
};
